var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center pl3"},[_c('h6',[_vm._v(_vm._s(_vm._f("toCurrency")(_vm.rate)))]),_c('div',{staticClass:"mh2"},[_vm._v("/")]),_c('div',{staticClass:"pv3 bodyCopy"},[_vm._v(_vm._s(_vm.interval))])])}
var staticRenderFns = []

export { render, staticRenderFns }